import { render, staticRenderFns } from "./ContratoDespesaForm.vue?vue&type=template&id=1036c81e&"
import script from "./ContratoDespesaForm.vue?vue&type=script&lang=js&"
export * from "./ContratoDespesaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports